import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const StonewashedBraToteBag = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.accessories.StonewashedBraToteBag.itemName}
      name={AW23.accessories.StonewashedBraToteBag.itemName}
      price={AW23.accessories.StonewashedBraToteBag.itemPrice}
      fabric={AW23.accessories.StonewashedBraToteBag.itemFabric}
      src={AW23.accessories.StonewashedBraToteBag.sizeChart}
      divId={AW23.accessories.StonewashedBraToteBag.shopifyDivId}
      mainId={AW23.accessories.StonewashedBraToteBag.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.accessories.StonewashedBraToteBag.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.accessories.StonewashedBraToteBag.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default StonewashedBraToteBag;
